export default __webpack_public_path__ + "static/baddaylight-7747a47a94b471539e51eebf10c0d7cd.png";